// extracted by mini-css-extract-plugin
module.exports = {"imageBlur":"Compliments_imageBlur__1qg28","imageSelect":"Compliments_imageSelect__qMOb2"};